import { render, staticRenderFns } from "./UploadOrdersMassiveComponent.vue?vue&type=template&id=6bc4a5df&scoped=true"
import script from "./UploadOrdersMassiveComponent.vue?vue&type=script&lang=js"
export * from "./UploadOrdersMassiveComponent.vue?vue&type=script&lang=js"
import style0 from "./UploadOrdersMassiveComponent.vue?vue&type=style&index=0&id=6bc4a5df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc4a5df",
  null
  
)

export default component.exports